import React, { useEffect, useState } from "react";
import { API_URL } from "../../../../constants";
import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
} from "../../../../services/serviceCaller";
import NewDynamic_PR_table from "../../../../components/NewDynamic_PR_Table";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";

const PR_Appraisal = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    fetchAppraisal();
    dispatch(updateNavbarHeading("PR Appraisal Cycle"))
  }, [])

  const [respStatus, setRepStatus] = useState('');
  const [PR_Appraisals, setPR_Appraisals] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const columns = {
    Code: { text: "Code", width: "60px", align: "center", visible: true },
    Name: { text: "Name", align: "start", visible: true },
    Description: { text: "Description", align: "start", visible: true },
    FromDate: { text: "From Date", align: "center", format: "date", visible: true },
    ToDate: { text: "To Date", align: "center", format: "date", visible: true },
    Active: { text: "Active", width: "40px", align: "center", visible: true },
    CreatedByName: { text: "Created By",width:"60px", visible: true },
  };


  const fetchAppraisal = async () => {
    setRepStatus(undefined);

    try {
      const response = await GetServiceCaller(`${API_URL}appraisal-cycles`);
      setRepStatus(response.status);
      if (response?.status == 200) {
        const data = response?.data?.data?.headers;
        setPR_Appraisals(data);

      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleEdit = async (id) => {
    navigate(`/appraisal-cycles/edit/${id.ID}`);
  };

  // Validate individual fields

  const handleAddNew = () => {

    navigate("/appraisal-cycles/add");
  };


  return (
    <>

      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={PR_Appraisals}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isRequiredStatus={true}
              isApiStatus={respStatus}
              showIcon1={true}
              showIcon2={false}
              isActionRequired={true}
              isAddNewBtnRequired={true}
              showIcon3={false}
              showIcon4={false}
              isSorting={true}
              showIcon5={false}
              handleIcon1={handleEdit}
              handleAddNew={handleAddNew}
              // handleIcon4={handleAddSubContractor}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon4: <i class="bi bi-plus-square icons"></i>,
                Icon4Text: " Add Sub-Contractor",
              }}
            />
          </div>
        </div>
      </div>

    </>
  );
};

export default PR_Appraisal;